import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import Logo from "../../image/S-TEE_logo.png";
import CbtEntryLink from "../../portal/CbtEntryLink";
import PortalEntryLink from "../../portal/PortalEntryLink";

const SOCIAL_LINKS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/steeschool",
    icon: <FaFacebookF />
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/steeschools/",
    icon: <FaLinkedinIn />
  },
  {
    label: "X",
    href: "https://x.com/steeschool",
    icon: <FaTwitter />
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/steeschools",
    icon: <FaInstagram />
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/channel/UCtTsMLjlskPQ3Vcfz3UINtA",
    icon: <FaYoutube />
  }
];

function Head() {
  return (
    <section className="head">
      <div className="container head-inner">
        <div className="logo-row">
          <Link className="logo-home" to="/" aria-label="Go to S-Tee Schools home">
            <img src={Logo} alt="S-Tee school logo" className="logo-img" />
          </Link>
          <div className="brand-column">
            <Link className="school-name-link" to="/">
              <span className="school-kicker school-kicker-history">Since 1978</span>
              <span className="school-name">S-Tee Schools</span>
            </Link>
            <div className="top-contact">
              <a className="contact-pill" href="mailto:info@steeschools.com">
                info@steeschools.com
              </a>
              <span className="contact-spacer" />
              <a className="contact-pill contact-pill-primary contact-phone-right" href="tel:+2347075152920">
                +234 707 515 2920
              </a>
            </div>
          </div>
        </div>
        <div className="header-links-group">
          <div className="portal-group">
            <span className="utility-label">Quick Links</span>
            <div className="portal-links">
              <PortalEntryLink className="portal-link" role="educator">
                Educator
              </PortalEntryLink>
              <PortalEntryLink className="portal-link" role="student">
                Student
              </PortalEntryLink>
              <PortalEntryLink className="portal-link" role="parent">
                Parent
              </PortalEntryLink>
              <CbtEntryLink className="portal-link">
                CBT
              </CbtEntryLink>
            </div>
          </div>
          <div className="social-row">
            <span className="utility-label">Connect</span>
            <div className="social-icons" aria-label="Social media">
              {SOCIAL_LINKS.map((socialLink) => (
                <a
                  key={socialLink.label}
                  className="social-icon"
                  href={socialLink.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visit S-Tee Schools on ${socialLink.label}`}
                  title={socialLink.label}
                >
                  {socialLink.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* header-base-row-flex removed as requested */}
    </section>
  );
}

export default Head;
